// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3H97O{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}@media(max-width:1023px){._3H97O{position:fixed;top:0;left:0;z-index:var(--zIndex-modal);width:100vw;height:100vh;border-radius:0;background:#fff;overflow-y:auto}}._3H97O>*{margin-bottom:1rem}@media(max-width:1023px){._3H97O>*{margin-bottom:0}}._3H97O>:last-child{margin-bottom:0}@media(max-width:1023px){.ycqGr{padding:1.03125rem 1.5rem .96875rem 1rem;border-bottom:1px solid #dcdddd;-ms-flex-order:-1;order:-1}}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"root": "_3H97O",
	"title": "ycqGr"
};
module.exports = exports;
